export default {
    locale: 'hi',
    country: 'IN',
    loginForm: {
        byAccountBtn: 'खाता पासवर्ड लॉगिन',
        byPhoneBtn: 'मोबाइल नंबर लॉगिन करें',
        accountPlaceholder: 'कृपया खाता दर्ज करें (डिफ़ॉल्ट खाता ADMIN)',
        passwordPlaceholder: 'कृपया पासवर्ड दर्ज करें (डिफ़ॉल्ट पासवर्ड 123456)',
        autoLogin: 'स्व - लॉगिन',
        forgetBtn: 'पासवर्ड भूल गए',
        loginBtn: 'लॉग इन करें',
        byAccountTip: {
            emptyErr: 'खाता खाली नहीं हो सकता'
        },
        byPasswordTip: {
            emptyErr: 'पासवर्ड रिक्त नहीं हो सकता'
        },
        byValidTip: {
            emptyErr: 'सत्यापन कोड भरना होगा'
        },
        sendMsg: {
            repeatErr: 'बार-बार मत भेजो',
            success: 'सफल',
            codeTip: 'आपका सत्यापन कोड है'
        },
        phonePlaceholder: 'कृपया फ़ोन नंबर दर्ज करें',
        validPlaceholder: 'सत्यापन कोड',
        validBtn: 'सत्यापन कोड प्राप्त करें',
        loginSuccess: 'लॉग इन सफल'
    },
    menuObj: {
        basicFeature: 'मूल क्षमता',
        cpUse: 'घटक उपयोग',
        childMenu: {
            0: 'मूल ढाँचा',
            1: 'मूल क्षमता',
            '0-0': 'वीयूई',
            '0-1': 'चींटी डिजाइन',
            '0-2': 'एडमिन Vue के पास',
            '1-0': 'फ्रेमवर्क फ़ंक्शन',
            '1-0-0': 'प्रोजेक्ट कॉन्फ़िगरेशन',
            '1-0-1': 'ललाट लॉग',
            '1-0-2': 'स्थानीय मॉक',
            '1-0-3': 'भूमंडलीकरण',
            '1-0-4': 'डेटा शब्दकोश',
            '1-0-5': 'इवेंटबस',
            '1-0-6': 'टूलसेट',
            '1-0-7': 'अभिगम नियंत्रण',
            '1-0-8': 'गर्म कुंजी',
            '1-1': 'पृष्ठ समारोह',
            '1-1-0': 'घटक पृष्ठ',
            '1-1-1': 'url पेज',
            '1-1-2': 'कोई अनुमति पृष्ठ नहीं',
            '1-1-3': '404 पृष्ठ'
        },
        errorTip: {
            notfoundTip: 'इस पथ के नीचे का घटक नहीं मिला',
            emptyErr: 'अपुष्ट घटक पथ'
        }
    },
    coreMenuObj: {
        defaultMenu: {
            home: 'घर'
        }
    },
    sysInfo: {
        sysIntro: 'Vue और चींटी डिजाइन पर आधारित एक उपयोगी मध्य और बैक-एंड फ्रंट-एंड डेवलपमेंट फ्रेमवर्क'
    },
    requestInfo: {
        withoutUrl: 'अनुरोध पता खाली नहीं हो सकता',
        networkErr: 'नेटवर्क अनुरोध विफल हुआ, कृपया बाद में पुनः प्रयास करें'
    },
    localeMap: {
        ar: 'अरबी',
        bg: 'बल्गेरियाई',
        ca: 'कातालान',
        cs: 'चेक',
        da: 'दानिश',
        de: 'जर्मन',
        el: 'यूनानी',
        'en-gb': 'अंग्रेज़ी',
        en: 'अंग्रेज़ी',
        es: 'स्पेनिश',
        et: 'एस्तोनियावासी',
        fa: 'फ़ारसी',
        fi: 'फिनिश',
        fr: 'फ्रेंच',
        he: 'यहूदी',
        hi: 'हिन्दी',
        hr: 'क्रोएशियाई',
        hu: 'हंगेरी',
        hy: 'अर्मेनियाई',
        id: 'इन्डोनेशियाई',
        is: 'आइसलैंड का',
        it: 'इतालवी',
        ja: 'जापानी',
        kn: 'कन्नड़',
        ko: 'कोरियाई',
        'ku-iq': 'केंद्रीय कुर्द',
        lv: 'केंद्रीय कुर्द',
        mk: 'मेसीडोनियन',
        'mn-mn': 'मंगोलियन',
        'ms-my': 'मलायी',
        nb: 'नार्वेजियन',
        'ne-np': 'नेपाली',
        'nl-be': 'फ्लेमिश',
        nl: 'डच',
        pl: 'पोलिश',
        'pt-br': 'ब्राजिलियन पुर्तगाली',
        pt: 'यूरोपीय पुर्तगाली',
        ro: 'रोमानियाई',
        ru: 'रूसी भाषा',
        sk: 'स्लोवाक',
        sl: 'स्लोवेनियाई',
        sr: 'सर्बियाई',
        sv: 'स्वीडिश',
        ta: 'तामिल',
        th: 'थाई',
        tr: 'तुर्की',
        uk: 'यूक्रेनी',
        vi: 'वियतनामी',
        'zh-cn': 'सरलीकृत चीनी',
        'zh-tw': 'परंपरागत चीनी'
    },
    tagObj: {
        closeAll: 'सभी टैब को बंद करें',
        closeCur: 'मौजूदा टैब बंद करें',
        closeOther: 'अन्य टैब बंद करें',
        closeRight: 'दायां लेबल बंद करें',
        singlePage: 'स्वतंत्र पृष्ठ',
        refreshPage: 'पृष्ठ ताज़ा करें',
        affixPage: 'पिन पेज',
        cancelAffixPage: 'अनपिन',
        errorTip: {
            homePageCloseError: 'मुखपृष्ठ को बंद करने की अनुमति नहीं है',
            affixPageCloseError: 'निश्चित पृष्ठ को बंद करने की अनुमति नहीं है',
            homePageAffixError: 'होमपेज अनपिन नहीं किया जा सकता है'
        },
        checkSave: 'क्या आप पृष्ठ को बंद करना चाहते हैं? (कृपया सुनिश्चित करें कि लाल रंग में चिह्नित पृष्ठ की सामग्री सहेज ली गई है)',
        cancelClose: 'बंद ऑपरेशन रद्द'
    },
    personalCenter: {
        frontendLog: 'ललाट लॉग',
        customSetting: 'निजीकरण',
        customClean: 'स्पष्ट विन्यास',
        cacheClean: 'कैश खाली करें',
        logout: 'प्रस्थान करें',
        errorTip: {
            cleanSuccess: 'सफलतापूर्वक खाली करें'
        }
    },
    errorPage: {
        errorTip: {
            notfoundTip: 'क्षमा करें, आपके द्वारा विज़िट किया गया पृष्ठ मौजूद नहीं है',
            notrightTip: 'क्षमा करें, आपके पास इस पृष्ठ तक पहुंचने की अनुमति नहीं है',
            noserviceTip: 'क्षमा करें, सर्वर में कोई समस्या थी, कृपया बाद में पुनः प्रयास करें'
        },
        btnText: 'पृष्ठ बंद करें'
    },
    searchPanel: {
        btn: {
            search: 'पूछताछ',
            shrink: 'जेल भेजना',
            reset: 'रीसेट',
            unshrink: 'उधेड़ना'
        }
    },
    logline: {
        list: 'लॉग लिस्ट',
        detail: 'लॉग विवरण',
        btnList: {
            export: 'निर्यात',
            remove: 'खाली'
        },
        time: {
            plh: 'कृपया समय सीमा चुनें',
            range: 'समय सीमा',
            halfDay: 'आधा दिन',
            oneDay: 'एक दिन में',
            weekDay: 'एक सप्ताह के अन्दर',
            monthDay: 'एक महीने के अंदर'
        },
        type: {
            logType: 'लॉग प्रकार',
            plh: 'कृपया लॉग प्रकार का चयन करें'
        },
        tableColumns: {
            index: 'क्रमांक',
            desc: 'लॉग विवरण',
            type: 'लॉग प्रकार',
            time: 'समय',
            op: 'ऑपरेटिंग'
        },
        request: 'डेटा का अनुरोध करें',
        error: {
            cancel: 'खाली संचालन रद्द',
            confirm: 'क्या आप लॉग को खाली करना चाहते हैं? (यदि लॉग खाली कर दिया जाता है, तो इसे पुनर्प्राप्त नहीं किया जा सकता)'
        },
        success: 'लॉग खाली कर दिया गया है'
    },
    comTable: {
        delete: {
            title: 'स्पष्ट विन्यास'
        },
        columns: {
            title: 'स्तंभ सेटिंग्स',
            all: 'सभी का चयन करे',
            reset: 'रीसेट',
            fixedLeft: 'निश्चित छोड़ दिया',
            fixedRight: 'निश्चित ही सही',
            cancelFixed: 'अनपिन'
        },
        size: {
            title: 'पंक्ति की ऊंचाई',
            small: 'संकीर्ण',
            normal: 'में',
            large: 'चौड़ाई'
        },
        fullscreen: 'पूर्ण स्क्रीन',
        unFullscreen: 'पूर्ण स्क्रीन रद्द करें'
    },
    normalBtn: {
        detail: 'राय'
    },
    setting: {
        customEntry: 'त्वरित प्रविष्टि',
        systemSwitch: 'प्रणाली विन्यास',
        isMock: 'चाहे मॉक',
        isHotKey: 'चाहे शॉर्टकट की',
        isBreadCrumb: 'चाहे ब्रेड क्रम्ब्स',
        isCache: 'चाहे कैशे करें',
        isI18n: 'चाहे अंतर्राष्ट्रीयकरण करना हो'
    },
    pagingInfo: {
        total: 'कुल मिलाकर',
        uint: 'लेख',
        items: 'रिकॉर्डिंग'
    }
}
